<template>
  <v-container grid-list-md text-xs-center>
    <TabOldCourse />
    <Table />
    <CourseDetial />
  </v-container>
</template>

<script>
import TabOldCourse from "../components/Tabs/TabOldCourse";
import Table from "../components/Table";
import CourseDetial from "../components/CourseDetial";

export default {
  components: {
    TabOldCourse,
    Table,
    CourseDetial,
  },
  mounted() {
    this.$store.commit("clearInfo");
  },
};
</script>
